import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-252">
      <div className="max-w-4xl mx-auto text-center" data-id="element-253">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#FFD700]/50 text-[#FFD700] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-254">
          🏆 El sistema más completo de planificación musical para docentes de
          habla hispana
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-[#FFD700] mb-6" data-id="element-255">
          🎵 MEGAPACK MÚSICA LISTA
        </h2>

        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-256">
          <strong data-id="element-257">12 tomos organizados por nivel y año.</strong> 240 clases con
          guion completo. 6 bonos estratégicos. Todo listo para usar desde hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-258">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-259">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
            backgroundColor: color,
            border: '2px solid #FFD700'
          }} data-id="element-260">
                <span className="text-white text-xs font-bold" data-id="element-261">{i + 1}°</span>
              </div>)}
          </div>
          <div className="text-gray-400 text-xs mt-1 mb-3 font-semibold tracking-wider" data-id="element-262">
            — Primaria / Básica
          </div>

          <div className="grid grid-cols-6 gap-2 justify-center mt-2" data-id="element-263">
            {['#1A237E', '#1B5E20', '#BF360C', '#4A148C', '#263238', '#3E2723'].map((color, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
            backgroundColor: color,
            border: '2px solid #FFD700'
          }} data-id="element-264">
                <span className="text-white text-xs font-bold" data-id="element-265">{i + 1}°</span>
              </div>)}
          </div>
          <div className="text-gray-400 text-xs mt-1 font-semibold tracking-wider" data-id="element-266">
            — Secundaria / Media
          </div>

          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#FFD700] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap mt-4" data-id="element-267">
            12 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-12" data-id="element-268">
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-269">
            ✅ Por nivel y año
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-270">
            ✅ Con guion completo
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-271">
            ✅ Con evaluación
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-272">
            ✅ Con 6 bonos
          </span>
        </div>
      </div>
    </section>;
}